import { render } from "./CustomCover.vue?vue&type=template&id=12f04efc"
import script from "./CustomCover.vue?vue&type=script&lang=js"
export * from "./CustomCover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__